import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "../../../component/layout";
import DashboardTab from "./tabs/dashboard_tab";
import TanksTab from "./tabs/tanks_tab";
import AlertsTab from "./tabs/alerts_tab";
import GatewaysTab from "./tabs/gateways_tab";
import "./water_sensors.css";

const TABS = [
  { key: "dashboard", label: "Dashboard", icon: "ti ti-dashboard" },
  { key: "tanks", label: "Tanks", icon: "ti ti-droplet" },
  { key: "alerts", label: "Alerts", icon: "ti ti-bell" },
  { key: "gateways", label: "Gateways", icon: "ti ti-router" },
];

const tabComponents = {
  dashboard: DashboardTab,
  tanks: TanksTab,
  alerts: AlertsTab,
  gateways: GatewaysTab,
};

// Water Level Sensors: tank levels from the LoRa water level sensors (water_level_service),
// limited to the tanks on gateways assigned to the selected facility
function WaterSensors() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(() => {
    const tab = searchParams.get("tab");
    return tabComponents[tab] ? tab : "dashboard";
  });

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    setSearchParams({ tab: tabName });
  };

  // Keep the tab in sync with the URL (browser back/forward)
  useEffect(() => {
    const urlTab = searchParams.get("tab");
    if (urlTab && tabComponents[urlTab] && urlTab !== activeTab) {
      setActiveTab(urlTab);
    }
  }, [searchParams, activeTab]);

  const TabComponent = tabComponents[activeTab];

  return (
    <Layout>
      <div className="water-sensors">
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12">
                <ul className="breadcrumb mb-3">
                  <li className="breadcrumb-item">
                    <Link to="/facility">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/facility/utility_management/meter_types">Meters Management</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    <span>Water Level Sensors</span>
                  </li>
                </ul>
                <div className="card">
                  <div className="card-header">
                    <Link to="/facility/utility_management/meter_types">
                      <i className="ti ti-arrow-narrow-left"></i> Back
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-body py-0">
                <ul className="nav nav-tabs profile-tabs" role="tablist">
                  {TABS.map((tab) => (
                    <li className="nav-item" key={tab.key}>
                      <button
                        className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                        onClick={() => handleTabChange(tab.key)}
                        type="button"
                      >
                        <i className={`${tab.icon} me-2`}></i>
                        {tab.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="tab-content">
              <TabComponent onTabChange={handleTabChange} />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default WaterSensors;
